export default __webpack_public_path__ + "static/media/WarrenDisplay-Bold.17dbb1ed.ttf";